import {
  addEdge,
  MarkerType,
  applyNodeChanges,
  applyEdgeChanges,
} from "@xyflow/react";
import {
  userIsLogged,
  getRoute,
  apiPostAvpArcoAdd,
  apiGetAvpAssistenteById,
  apiGetAvpGrafo,
  apiGetAllSysLingue,
  apiGetAvpNodoTipoAvvio,
} from "../../shared/manager/api_manager";
import { getValueByQueryString } from "../../shared/manager/util";

import { create } from "zustand";
import { type } from "@testing-library/user-event/dist/type";

export const useGraphStore = create((set, get) => ({
  alertMessage: "",
  selectedNode: undefined,
  selectedLingua: undefined,
  tipoAvvioList: [],
  avp: null,
  nodes: [],
  edges: [],
  hiddenNode: [],
  setAlertMessage: (state) => {
    set({alertMessage:state});
  },
  updateHiddenNode: (idNode) => {
    let hiddenNode = get().hiddenNode;
    const find = hiddenNode.find((n) => String(n) === String(idNode));
    if (find) {
      hiddenNode = hiddenNode.map((n) => {
        if (String(n) !== String(idNode)) return n;
        else {
          return;
        }
      });
    } else {
      hiddenNode.push(idNode);
    }
    set({ hiddenNode: hiddenNode });
  },
  onNodesChange: (changes) => {
    set({
      nodes: applyNodeChanges(changes, get().nodes),
    });
  },
  setSelectedLingua: (lingia) => {
    set({ selectedLingua: lingia });
  },
  onEdgesChange: (changes) => {
    set({
      edges: applyEdgeChanges(changes, get().edges),
    });
  },
  onConnect: (connection) => {
    set({
      edges: addEdge(connection, get().edges),
    });
  },
  setNodes: (nodes) => {
    set({ nodes: nodes });
  },
  setEdges: (edges) => {
    set({ edges: edges });
  },
  setSelectedNode: (idNode) => {
    if (idNode === undefined) {
      set({ selectedNode: undefined });
      return;
    }
    const nodeStarter = get().avp;
    const selectedNode = nodeStarter.nodi.find(
      (n) => String(n.idNodo) === String(idNode)
    );
    set({ selectedNode: selectedNode });
  },
  setAvp: (avp) => {
    set({ avp: avp });
  },
  aggiornaAvp: (idAvp) => {
    const selectedLingua = get().selectedLingua;
    apiGetAvpGrafo(idAvp, selectedLingua.idLingua, function (response) {
      set({ avp: response.data });
    });
  },
  start: () => {
    const avp = get().avp;
    const hiddenNode = get().hiddenNode;
    const nodeList = [];
    const edgeList = [];
    const elaboratedNode = [];

    const nodeRadius = 0;
    const levelHeight = 220;
    const horizontalSpacing = 180;
    const CalculateLayout = (node, depth = 0, leftmostX = 0) => {
      elaboratedNode.push({ id: node.idNodo });
      node.archi
        .filter((a) => !a.terminaSessione)
        .forEach((a) => {
          edgeList.push({
            id: String(a.idArco),
            style: a.nonAttivo
              ? { stroke: "#CCCCCC", strokeWidth: 2 }
              : a.formato === "back"
              ? { stroke: "green", strokeWidth: 2 }
              : { stroke: "black", strokeWidth: 2 },
            animated: a.formato === "back",
            type: a.formato === "back" ? "bezier" : "customEdge",
            // type: a.formato === "back" ? "customBackEdge" : "customEdge",
            data: { label: a.testo, nonAttivo: a.nonAttivo,idAvp:avp.idAvp,idNodo:a.idNodoStart },
            source: String(a.idNodoStart),
            target: String(a.idNodoEnd),
            sourceHandle: a.formato === "back" ? "bs" : "as",
            targetHandle: a.formato === "back" ? "bt" : "at",
            markerEnd: {
              type: MarkerType.ArrowClosed,
              width: 20,
              height: 20,
              color: a.nonAttivo
                ? "#CCCCCC"
                : a.formato === "back"
                ? "green"
                : "black",
              // color: a.formato === "back" ? "green" : "#FF0072",
            },
          });
        });
      const terminaSessione = node.archi.find((a) => a.terminaSessione);
      let childrenArchi = [];
      let totalWidth = 0;
      const childrenCenters = [];
      let currentX = leftmostX;
      const find = hiddenNode.find((n) => n === String(node.idNodo));
      if (!find) {
        childrenArchi = node.archi
          .filter((a) => a.formato !== "back" && !a.terminaSessione)
          .sort(function (a, b) {
            return a.ordine - b.ordine;
          });
        if (childrenArchi.length === 0) {
          nodeList.push({
            id: String(node.idNodo),
            data: {
              label: node.descNodo,
              nodoStart: node.nodoStart,
              nonAttivo: node.nonAttivo,
              terminaSessione: terminaSessione,
            },
            type: "textUpdater",
            position: { x: leftmostX, y: depth * levelHeight + 50 },
            depth: depth,
          });

          return { width: nodeRadius * 2, center: leftmostX };
        }

        for (let i = 0; i < childrenArchi.length; i++) {
          const child = childrenArchi[i];
          if (elaboratedNode.find((e) => e.id === child.idNodoEnd)) continue;
          const childNode = avp.nodi.find((n) => n.idNodo === child.idNodoEnd);

          const childLayout = CalculateLayout(childNode, depth + 1, currentX);
          currentX += childLayout.width + horizontalSpacing;
          totalWidth += childLayout.width;
          if (i < childrenArchi.length - 1) {
            totalWidth += horizontalSpacing;
          }
          childrenCenters.push(childLayout.center);
        }
      }

      const posX =
        childrenCenters.length > 0
          ? (childrenCenters[0] + childrenCenters[childrenCenters.length - 1]) /
            2
          : leftmostX + nodeRadius;
      nodeList.push({
        id: String(node.idNodo),
        data: {
          label: node.descNodo,
          nodoStart: node.nodoStart,
          nonAttivo: node.nonAttivo,
          terminaSessione: terminaSessione,
        },
        type: "textUpdater",
        depth: depth,

        position: { x: posX, y: depth * levelHeight + 50 },
      });
      return { width: totalWidth, center: posX };
    };
    if (avp.nodi !== undefined)
      CalculateLayout(avp.nodi.find((n) => n.nodoStart));

    // CalculateLayout(avp.nodi.find((n) => n.descNodo === "START"));
    let selectedNode = get().selectedNode;
    if (selectedNode !== undefined) {
      selectedNode = avp.nodi.find((n) => n.idNodo == selectedNode.idNodo);
    }
    set({
      nodes: nodeList,
      edges: edgeList,
      avp: avp,
      selectedNode: selectedNode,
    });
  },
}));
